/* eslint-disable react/prefer-es6-class, react/sort-comp */
import React from 'react';

/**
 * The proper way to stack these is in the format. Unfortunately,
 * jQuery UI will always round the numbers, so the range cannot
 * be between 0 and 1.
 *
 * <Slider max={10} min={0} onChange={someFunction} value={5} />
 *
 * @requires jQuery UI
 */

export const Slider = React.createClass({
  displayName: 'Slider',

  propTypes: {
    min: React.PropTypes.number.isRequired,
    max: React.PropTypes.number.isRequired,
    onChange: React.PropTypes.func.isRequired,
    value: React.PropTypes.number.isRequired,
  },

  getInitialState() {
    return {
      value: this.props.value,
    };
  },

  /**
   * Setup the component based on the values.
   */
  componentDidMount() {
    const slider = $(this.refs.slider).slider({
      max: this.props.max,
      min: this.props.min,
      slide: this._updateValue,
      stop: this._updateValue,
      value: this.state.value,
    });

    $('.ui-slider-handle', slider).addClass('handle');
  },

  /**
   * If the properties are going to update, change the slider position.
   */
  componentWillReceiveProps(nextProps) {
    if (isFinite(nextProps.value)) {
      this.setState({ value: nextProps.value });
    }

    $(this.refs.slider).slider('value', nextProps.value);
  },

  /**
   * Simply destroy the slider events.
   */
  componentWillUnmount() {
    $(this.refs.slider).slider('destroy');
  },

  render() {
    const barStyle = {
      width: `${(this.state.value / this.props.max) * 100}%`,
    };

    return (
      <span ref="slider" className="slider-bar">
        <span ref="bar" className="bar" style={barStyle} />
      </span>
    );
  },

  /**
   * Helper for the slide and stop callbacks.
   */
  _updateValue(event, ui) {
    const value = ui.value;

    this.setState({ value });
    this.props.onChange.call(this, value);
  },
});

export default Slider;
